export default "/statistics";
